import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/Layout'

Vue.use(Router)

function load (view) {
  return () => import(`@/views/${view}.vue`)
}

export default new Router({
  routes: [
    { path: '/login', component: load('Login'), hidden: true },
    {
      path: '/',
      component: Layout,
      children: [
        { path: '/', name: '基础查询', component: load('inquire/basics/QueryRole'), icon: 'fa fa-home' }
      ]
    },
    {
      path: '/t',
      component: Layout,
      subMenu: false,
      name: 'template',
      icon: 'fa fa-ticket',
      children: [{ path: '/t/ai', name: '模板资源', component: load('template/Template'), icon: 'fa fa-area-chart' }]
    },
    {
      path: '/r',
      component: Layout,
      subMenu: true,
      name: '角色管理',
      icon: 'fa fa-database',
      children: [{ path: '/r/rs', name: '角色搜索', component: load('role/RoleSearch'), icon: 'fa fa-bar-chart' },
        { path: '/r/ri', name: '角色详情', component: load('role/RoleInfo'), icon: 'fa fa-bar-chart' }]
    },
    {
      path: '/o',
      component: Layout,
      subMenu: false,
      name: 'operation',
      icon: 'fa fa-yen',
      children: [{ path: '/o/k', name: '运营管理', component: load('operation/Operation'), icon: 'fa fa-area-chart' }]
    },
    {
      path: '/m',
      component: Layout,
      subMenu: false,
      name: 'mail',
      icon: 'fa fa-yen',
      children: [{ path: '/m/m', name: '发送邮件', component: load('mail/Mail'), icon: 'fa fa-area-chart' }]
    },
    // Always leave this last one
    { path: '*', component: load('Error404'), hidden: true }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js